import { FC, ReactElement, ReactNode } from 'react'
import cn from 'classnames'

import { useCheckMobile } from '@/hooks/useCheckMobile'
import { DIRECTION } from '@/context/constants'

import './styles.css'

interface ChatBubbleProps {
  direction: 'left' | 'right'
  children: ReactNode | ReactElement
  isForm?: boolean
  classname?: string
}

const ChatBubble: FC<ChatBubbleProps> = ({
  direction,
  children,
  isForm,
  classname,
}) => {
  const isMobile = useCheckMobile()

  return (
    <div
      className={cn('pmui-flex pmui-w-full', {
        'pmui-justify-end': direction === DIRECTION.RIGHT,
      })}
    >
      <div
        className={cn(
          'pmui-mt-1.5 pmui-p-3',
          { 'chat-bubble': !isMobile },
          {
            'pmui-text-white pmui-bg-[#5db5f0] pmui-rounded-tl-xl pmui-rounded-b-xl pmui-justify-end':
              direction === DIRECTION.RIGHT,
          },
          {
            'pmui-text-[#383F4A] pmui-bg-[#f7f7f7] pmui-rounded-tr-xl pmui-rounded-b-xl':
              direction === DIRECTION.LEFT,
          },
          {
            'pmui-w-full pmui-p-0': isForm,
          },
          {
            'pmui-w-fit': !isForm,
          },
          classname,
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default ChatBubble
